import request from '@/utils/request'

export function addVideo (file) {
  let data = new FormData()
  data.append('bookId', file.bookId)
  data.append('chapterId', file.chapterId)
  data.append('desc', file.desc)
  data.append('note', file.note)
  data.append('file', file.file)
  return request({
    url: `/platform/video`,
    method: 'post',
    data
  })
}

export function delVideo (id) {
  return request({
    url: `/platform/video/${id}`,
    method: 'delete'
  })
}

export function editVideo (file, id) {
  let data = new FormData()
  data.append('bookId', file.bookId)
  data.append('chapterId', file.chapterId)
  data.append('code', file.code)
  data.append('qrCode', file.qrCode)
  data.append('desc', file.desc)
  data.append('note', file.note)
  data.append('file', file.file)
  return request({
    url: `/platform/video/${id}`,
    method: 'patch',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/video.js